// FileUpload.js
import { useState } from "react";
import classes from "./FileUpload.module.css";
import FileIcon from "../../../icons/FileIcon";

const FileUpload = ({ onFileSelect, label, buttonText }) => {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      setFile({
        raw: selectedFile, // keep the actual file
        name: selectedFile.name,
        size: (selectedFile.size / (1024 * 1024)).toFixed(2) + " MB",
        type: "." + selectedFile.name.split(".").pop(),
      });

      onFileSelect(selectedFile); // send file to parent
    }
  };

  const handleRemove = () => {
    setFile(null);
    onFileSelect(null); // clear in parent too
  };

  return (
    <div className={classes.uploadContainer}>
      <label className={classes.uploadLabel}>{label}</label>

      {!file ? (
        <div>
          <input
            type="file"
            id="fileInput"
            accept=".pdf,.jpg,.png"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          <label htmlFor="fileInput" className={classes.uploadBtn}>
            {buttonText}
          </label>
        </div>
      ) : (
        <div className={classes.fileCard}>
          <div className={classes.fileInfo}>
            <FileIcon />
            <div>
              <p className={classes.fileName}>{file.name}</p>
              <p className={classes.fileMeta}>
                {file.type} | {file.size}
              </p>
            </div>
          </div>

          <div className={classes.uploadActions}>
            {/* <div className={classes.progressCircle}></div> */}
            <button
              type="button"
              onClick={handleRemove}
              className={classes.removeBtn}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FileUpload;